var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSendArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "action/small/send/default copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3Nickels-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small",
    transform: "translate(-1057, -45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "action/small/send/default-copy",
    transform: "translate(1057, 45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9, 6.4976)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.88349723,0.325090265 L11.6669983,5.00417313 C12.0976959,5.42546919 12.1053175,6.11614659 11.6840214,6.54684428 C11.6784098,6.5525811 11.6727351,6.55825583 11.6669983,6.56386742 C11.2238716,6.99732111 10.5156245,6.99732111 10.0724979,6.56386742 L7.125,3.681 L7.12501916,16.8748862 C7.12501916,17.4975773 6.62022828,18.0023682 5.99753716,18.0023682 C5.37484604,18.0023682 4.87005515,17.4975773 4.87005515,16.8748862 L4.87,3.68 L1.9225764,6.56386742 C1.47944978,6.99732111 0.771202672,6.99732111 0.328076055,6.56386742 C-0.10262163,6.14257135 -0.110243149,5.45189396 0.311052915,5.02119627 C0.316664508,5.01545945 0.322339234,5.00978472 0.328076055,5.00417313 L5.11157709,0.325090265 C5.35604299,0.085960763 5.68119973,-0.0212447976 5.99801561,0.00347358295 C6.31387458,-0.0212447976 6.63903132,0.085960763 6.88349723,0.325090265 Z",
    id: "Combined-Shape"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSendArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send_arrow.4e8c53d004c5becaddd3aaf6606acb60.svg";